module.exports = __webpack_public_path__ + "static/media/drop-down-n.19cd84bc.svg";